<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-left xs12 md3 px-3 v-if="!currentContractor">
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentContractor" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-left xs12 md3 v-if="currentContractor">
            <v-btn flat @click="openPrintProductionReportDialog" class="bw-7">Print production report</v-btn>
          </v-flex>
          <v-flex text-xs-right xs12 md9>
            <v-btn flat v-if="!currentContractor" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentContractor" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentContractor" v-on:click="editNewContractor" class="bw-6">Create new contractor</v-btn>
            <v-btn flat v-if="currentContractor" :disabled="saveButtonDisabled" v-on:click="save" class="bw-3">{{ currentContractor.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="canDelete" v-on:click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentContractor" v-on:click="cancel" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentContractor" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredContractors" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click="selectRow(props.item)" class="selectable">
                  <td class="text-xs-left">{{ props.item.name }}</td>
                  <td class="text-xs-left">{{ props.item.vat }}</td>
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.phone }}</td>
                  <td class="text-xs-left">{{ props.item.mobile }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <Panel v-if="currentContractor">
        <PanelColumn title="Contractor">
          <v-flex xs4 md2>
            <v-label>Name</v-label>
          </v-flex>
          <v-flex xs8 md5>
            <v-text-field color="teal" v-model="currentContractor.name" ref="name" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md1/>
          <v-flex xs4 md2>
          </v-flex>
          <v-flex xs8 md2>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>E-mail</v-label>
          </v-flex>
          <v-flex xs8 md5>
            <v-text-field color="teal" v-model="currentContractor.email" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md1/>
          <v-flex xs4 md2>
            <v-label>VAT no.</v-label>
          </v-flex>
          <v-flex xs8 md2>
            <v-text-field color="teal" v-model="currentContractor.vat" style="width: 120px;" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>Phone</v-label>
          </v-flex>
          <v-flex xs8 md5>
            <v-text-field color="teal" v-model="currentContractor.phone" style="width: 120px;" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 md1/>
          <v-flex xs4 md2>
            <v-label>Mobile</v-label>
          </v-flex>
          <v-flex xs8 md2>
            <v-text-field color="teal" v-model="currentContractor.mobile" style="width: 120px;" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 md2>
            <v-label>Inactive</v-label>
          </v-flex>
          <v-flex xs8 md10>
            <v-checkbox color="teal" v-model="currentContractor.inactive"/>
          </v-flex>
          <v-flex xs12/>
        </PanelColumn>

        <v-flex xs12 px-5 py-3 text-xs-center>
        </v-flex>

        <PanelColumn2 title="Address">
          <v-flex xs4 sm4>
            <v-label>Street</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.street" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>House no.</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Location</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.location" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Postal code</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>City</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.city" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Country</v-label>
          </v-flex>
          <v-flex xs8 sm8 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.country" autocomplete="offit"></v-text-field>
          </v-flex>

          <v-flex xs4 sm4>
            <v-label>Geo code</v-label>
          </v-flex>
          <v-flex xs4 sm4 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.latitude" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs4 sm4 style="padding-left: 10px;">
            <v-text-field color="teal" v-model="currentContractor.address.longitude" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs12 text-xs-right>
            <v-btn @click="$refs.maps.addressToGeo(currentContractor.address)" flat>Lookup geo code</v-btn>
          </v-flex>
        </PanelColumn2>
        <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
        <PanelColumn2 style="padding-top: 25px;">
          <Maps v-model="currentContractor.address" ref="maps" height="285px"/>
        </PanelColumn2>
      </Panel>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete contractor</v-card-title>
        <v-card-text v-if="currentContractor">Are you sure you want to delete '{{ currentContractor.name }}'?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="printProductionReportDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Print production report</v-card-title>
        <v-card-text>
          <div style="padding: 5px 20px 0 20px;">
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td class="printOptions">
                  <v-radio-group v-model="printMode">
                    <v-radio value="BY_FIELD" color="#004d40" label="Field status"></v-radio>
                    <v-radio value="BY_DATE" color="#004d40" label="Daily production"></v-radio>
                  </v-radio-group>
                </td>
                <td class="printOptions">
                  <v-radio-group v-model="produced">
                    <v-radio :value="false" color="#004d40" label="Planned"></v-radio>
                    <v-radio :value="true" color="#004d40" label="Produced"></v-radio>
                  </v-radio-group>
                </td>
              </tr>
            </table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="printProductionReport" class="bw-3">Print</v-btn>
          <v-btn flat @click="printProductionReportDialog = false" class="bw-3">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import axios from 'axios'

export default {
  name: 'Contractors',
  components: {Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, Maps},
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'VAT', value: 'vat', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Phone', value: 'phone', sortable: false },
        { text: 'Mobile', value: 'mobile', sortable: false }
      ],
      contractors: [],
      currentContractor: null,
      confirmDeleteDialog: false,
      printProductionReportDialog: false,
      printMode: 'BY_FIELD',
      produced: false,
      filterInactive: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'contractors' })
    this.loadContractors()
  },
  computed: {
    users: function () {
      return this.$store.state.user.users
    },
    saveButtonDisabled: function () {
      return !this.currentContractor || this.currentContractor.name.trim() === ''
    },
    canDelete: function () {
      return this.currentContractor && this.currentContractor.id > 0
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredContractors () {
      return this.contractors.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    }
  },
  methods: {
    loadContractors () {
      // console.log('Loading contractors')
      axios.get('/backend/rest/contractor/all')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.contractors = response.data
          // console.log('Contractors: ' + this.contractors)
        })
    },
    selectRow (item) {
      for (let c of this.contractors) {
        if (c.id === item.id) {
          this.currentContractor = c
          // console.log('Latitude is: ' + this.currentContractor.address.latitude)
          if (this.currentContractor.address.latitude === 0) {
            this.currentContractor.address.latitude = ''
          }
          if (this.currentContractor.address.longitude === 0) {
            this.currentContractor.address.longitude = ''
          }
          break
        }
      }
      // console.log('The current contractor is: ' + this.currentContractor.name)
    },
    editNewContractor () {
      // console.log('Create a new contractor')
      this.currentContractor = {
        id: 0,
        name: '',
        vat: '',
        email: '',
        phone: '',
        mobile: '',
        address: {
          street: '',
          houseNo: '',
          location: '',
          zipCode: '',
          city: '',
          country: '',
          latitude: '',
          longitude: ''
        }
      }
      this.$nextTick(() => this.$refs.name.focus())
    },
    save () {
      // console.log('Save the contractor')
      axios.post('/backend/rest/contractor', this.currentContractor)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadContractors()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentContractor = null
    },
    delete () {
      // console.log('Delete contractor: ' + this.currentContractor.name)

      axios.delete('/backend/rest/contractor/' + this.currentContractor.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadContractors()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentContractor = null
    },
    cancel () {
      // console.log('Cancel the contractor')
      this.currentContractor = null
      this.loadContractors()
    },
    openPrintProductionReportDialog () {
      this.printProductionReportDialog = true
    },
    printProductionReport () {
      this.printProductionReportDialog = false
      let url = '/backend/print/'
      if (this.printMode === 'BY_FIELD') {
        url += 'contractorProductionReport.xhtml?contractorId=' + this.currentContractor.id
      } else if (this.printMode === 'BY_DATE') {
        url += 'contractorProductionReportByDate.xhtml?contractorId=' + this.currentContractor.id
      }
      url += '&produced=' + this.produced
      setTimeout(function () {
        window.open(url)
      }, 500)
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Contractors.vue